import React from "react"
import Slider from "react-slick"
import UserTestimonio from "../../images/Chantal.png"
import UserTestimonio2 from "../../images/Nahuel.png"
import Comillas from "../../images/comillas.png"

const Testimonios = () => {
  var settings = {
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 500,
    swipeToSlide: true,
  }
  return (
    <section className="bg-primary text-white relative z-0">
      <div className="mx-auto container px-8 py-20">
        <Slider {...settings}>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
            <div className="justify-self-end">
              <img src={UserTestimonio} alt="Chantal Boad" />
            </div>
            <div className="col-span-2">
              <h3 className="text-5xl font-bold pb-8">A unique experience!</h3>
              <p className="text-xl pb-8">
                As regards my personal experience, I think that it was a great
                opportunity to strengthen my relationship with my peers.
              </p>
              <h4 className="text-4xl pb-2">Chantal Boado</h4>
              <h5 className="text-3xl">Front-end Developer</h5>
            </div>
            <div>
              <img src={Comillas} alt="Chantal Boad" />
            </div>
          </div>
          {/* Testimonio 2 */}
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 place-content-evenly">
            <div className="justify-self-end">
              <img src={Comillas} alt="Nahuel Lavrut" />
            </div>
            <div className="col-span-2">
              <h3 className="text-5xl font-bold pb-8">
                I would love to return!
              </h3>
              <p className="text-xl pb-8">
                It was a hyper important experience, one that generated lifelong
                friendships.
              </p>
              <h4 className="text-4xl pb-2">Nahuel Lavrut</h4>
              <h5 className="text-3xl">Full-Stack Developer</h5>
            </div>
            <div>
              <img src={UserTestimonio2} alt="Nahuel Lavrut" />
            </div>
          </div>
          {/* Testimonio 3 */}
          {/* <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
            <div className="justify-self-end">
              <img src={UserTestimonio} alt="Chantal Boad" />
            </div>
            <div className="col-span-2">
              <h3 className="text-5xl font-bold pb-8">Jonathan Montaluisa</h3>
              <h4 className="text-4xl pb-8">Software Developer</h4>
              <p>
                In in sagittis arcu, vel malesuada sapien. Mauris accumsan
                laoreet magna, at porta eros consequat eu. Nullam turpis mi,
                pretium ut placerat a, ultrices ut sapien. Phasellus malesuada
                tellus nibh, dictum eleifend justo commodo quis. Nullam eleifend
                fringilla faucibus.
              </p>
            </div>
            <div>
              <img src={Comillas} alt="Chantal Boad" />
            </div>
          </div> */}
          {/* Testimonio 4 */}
          {/* <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 place-content-evenly">
            <div className="justify-self-end">
              <img src={Comillas} alt="Chantal Boad" />
            </div>
            <div className="col-span-2">
              <h3 className="text-5xl font-bold pb-8">Pablo Morgenstern</h3>
              <h4 className="text-4xl pb-8">People and Culture Manager</h4>
              <p>
                ¡Una experiencia única! Me sirvió mucho en mi experiencia
                personal para afianzar mi relación con mis compañeros.
              </p>
            </div>
            <div>
              <img src={UserTestimonio} alt="Chantal Boad" />
            </div>
          </div> */}
        </Slider>
      </div>
    </section>
  )
}

export default Testimonios
